import React from 'react';
import { Table, Typography, Tag } from 'antd';
import { clientReports as data } from '../../mockData';
import './ClientReports.css';

function ClientReports() {
  const { Title, Text } = Typography;

  // Data now sourced from centralized mockData

  const columns = [
    { title: 'Client', dataIndex: 'client', key: 'client', sorter: (a, b) => a.client.localeCompare(b.client) },
    { title: 'Period', dataIndex: 'period', key: 'period' },
    { title: 'Impressions', dataIndex: 'impressions', key: 'impressions', align: 'right', sorter: (a, b) => a.impressions - b.impressions, render: (v) => v.toLocaleString() },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', align: 'right', sorter: (a, b) => a.clicks - b.clicks, render: (v) => v.toLocaleString() },
    { title: 'Conversions', dataIndex: 'conversions', key: 'conversions', align: 'right', sorter: (a, b) => a.conversions - b.conversions, render: (v) => v.toLocaleString() },
    { title: 'CTR', key: 'ctr', align: 'right', render: (_, r) => `${((r.clicks / r.impressions) * 100).toFixed(2)}%` },
    { title: 'CPA', key: 'cpa', align: 'right', render: (_, r) => `$${(r.spend / Math.max(r.conversions, 1)).toFixed(2)}` },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'active' ? 'green' : 'default'}>{s.toUpperCase()}</Tag> },
  ];

  const total = data.reduce((acc, r) => ({
    impressions: acc.impressions + r.impressions,
    clicks: acc.clicks + r.clicks,
    conversions: acc.conversions + r.conversions,
    spend: acc.spend + r.spend,
  }), { impressions: 0, clicks: 0, conversions: 0, spend: 0 });

  return (
    <div className="agency-analytics-client-reports">
      <Title level={3} style={{ marginBottom: 16 }}>Client-by-Client Reports</Title>
      <div style={{ marginBottom: 12 }}>
        <Text type="secondary">
          Total: {total.impressions.toLocaleString()} impressions • {total.clicks.toLocaleString()} clicks • {total.conversions.toLocaleString()} conversions • ${total.spend.toLocaleString()} spend
        </Text>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 5 }}
      />
    </div>
  );
}

export default ClientReports;
